import React from 'react';
import { Box, Typography, Button, Container, Paper } from '@mui/material';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import ChatIcon from '@mui/icons-material/Chat';

const Home = () => {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default' }}>
      <Navbar />
      <Box 
        sx={{ 
          position: 'fixed', 
          top: 0, 
          left: 0, 
          right: 0, 
          bottom: 0, 
          background: 'linear-gradient(135deg, rgba(220, 20, 60, 0.1) 0%, rgba(58, 53, 50, 0.05) 100%)',
          zIndex: -1 
        }} 
      />

      <Container maxWidth="lg">
        <Box
          sx={{
            mt: 8,
            mb: 12,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center',
            gap: 4,
          }}
        >
          <Box sx={{ flex: 1, textAlign: { xs: 'center', md: 'left' } }}>
            <Paper
              elevation={0}
              sx={{
                p: 4,
                background: 'rgba(255, 255, 255, 0.8)',
                backdropFilter: 'blur(10px)',
                borderRadius: 4,
                border: '1px solid rgba(220, 20, 60, 0.1)',
              }}
            >
              <Typography 
                variant="h3" 
                component="h1" 
                gutterBottom
                sx={{ 
                  fontWeight: 700,
                  color: '#dc143c'
                }}
              >
                Resume Parser & Analyzer
              </Typography>
              <Typography variant="h6" color="text.secondary" paragraph>
                Upload resumes and job descriptions to find the best matches using advanced AI analysis. 
                Get instant insights and make better hiring decisions.
              </Typography>
              <Button
                component={Link}
                to="/upload"
                variant="contained"
                size="large"
                startIcon={<CloudUploadIcon />}
                sx={{
                  mt: 2,
                  px: 4,
                  py: 1.5,
                  borderRadius: 2,
                  textTransform: 'none',
                  fontSize: '1.1rem',
                  backgroundColor: '#dc143c',
                  '&:hover': {
                    backgroundColor: '#b01030',
                  }
                }}
              >
                Get Started
              </Button>
            </Paper>
          </Box>

          <Box 
            sx={{ 
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
            }}
          >
            <img
              src="/Image/main-first.png"
              alt="Resume Analysis"
              style={{
                width: '100%',
                maxWidth: '500px',
                height: 'auto',
                filter: 'drop-shadow(0px 10px 20px rgba(220, 20, 60, 0.15))',
              }}
            />
          </Box>
        </Box>

        <Box sx={{ mb: 12 }}>
          <Typography 
            variant="h4" 
            component="h2" 
            align="center" 
            gutterBottom
            sx={{ 
              fontWeight: 600, 
              mb: 6,
              color: '#3a3532'
            }}
          >
            Key Features
          </Typography>

          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
              gap: 4,
            }}
          >
            <FeatureCard
              icon={<CloudUploadIcon sx={{ fontSize: 40 }} />}
              title="Resume Parsing"
              description="Extract key information from resumes automatically using advanced AI technology."
              image="/Image/product.png"
            />
            <FeatureCard
              icon={<AnalyticsIcon sx={{ fontSize: 40 }} />}
              title="Intelligent Matching"
              description="Match resumes with job descriptions using sophisticated algorithms for accurate results."
              image="/Image/resume.png"
            />
            <FeatureCard
              icon={<ChatIcon sx={{ fontSize: 40 }} />}
              title="Interactive Chat"
              description="Ask questions about candidates and get instant, AI-powered answers."
              image="/Image/cb.png"
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

const FeatureCard = ({ icon, title, description, image }) => (
  <Paper
    elevation={0}
    sx={{
      p: 4,
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      background: 'rgba(255, 255, 255, 0.8)',
      backdropFilter: 'blur(10px)',
      borderRadius: 4,
      border: '1px solid rgba(220, 20, 60, 0.1)',
      transition: 'transform 0.2s ease-in-out',
      '&:hover': {
        transform: 'translateY(-5px)',
        boxShadow: '0 8px 32px rgba(220, 20, 60, 0.15)',
      },
    }}
  >
    <Box sx={{ color: '#dc143c', mb: 2 }}>
      {icon}
    </Box>
    <Typography variant="h6" gutterBottom align="center" sx={{ fontWeight: 600, color: '#3a3532' }}>
      {title}
    </Typography>
    <Typography color="text.secondary" align="center" sx={{ mb: 3 }}>
      {description}
    </Typography>
    <Box
      sx={{
        mt: 'auto',
        width: '100%',
        maxWidth: 200,
        height: 'auto',
        opacity: 0.9,
      }}
    >
      <img
        src={image}
        alt={title}
        style={{
          width: '100%',
          height: 'auto',
        }}
      />
    </Box>
  </Paper>
);

export default Home;
